"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_consumer_nav_1 = require("@snapchat/web-consumer-nav");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_page_view_1 = require("@snapchat/web-page-view");
const react_1 = require("react");
const messageLoader_1 = require("../../i18n/messageLoader");
const react_intl_1 = require("react-intl");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_head_meta_1 = require("@snapchat/web-head-meta");
const web_env_1 = require("@snapchat/web-env");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const PageFrame_1 = require("../PageFrame");
const downloadUrlGenerator_1 = require("../../downloadUrlGenerator");
const NoContentPage_1 = require("../NoContentPage");
/**
 * Error page
 */
function ErrorPage(props) {
    const pageType = web_blizzard_reporting_1.PageType.ERROR;
    const { locale, messages, changeLocale } = (0, web_i18n_1.useLocale)({
        loadMessages: messageLoader_1.loadMessages,
    });
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)() || "";
    const { traceId } = (0, web_page_view_1.useGenerateWebPageViewTraceId)();
    (0, react_1.useEffect)(() => {
        void (0, web_graphene_reporting_1.incrementCounter)(`${props.grafanaBasePrefix}.ErrorPageView`);
    }, [props.grafanaBasePrefix]);
    (0, react_1.useEffect)(() => {
        (0, web_blizzard_reporting_1.reportWebPageView)({
            webClientId,
            traceId,
            pageType,
        });
    }, [pageType, webClientId, traceId]);
    const headMetaProps = (0, react_1.useMemo)(() => ({
        isProd: (0, web_env_1.isProd)(),
        direction: (0, web_i18n_1.getDirectionForLocale)(locale),
        title: "Snapchat",
        policyDirectives: props.policyDirectives,
        lang: locale,
        snapchatDeepLinkUrl: "https://link.snapchat.com/unlock",
    }), [locale, props.policyDirectives]);
    return ((0, jsx_runtime_1.jsxs)(react_intl_1.IntlProvider, { locale: locale, messages: messages, defaultLocale: web_i18n_1.Locale.enUS, children: [(0, jsx_runtime_1.jsx)(web_head_meta_1.HeadMeta, { ...headMetaProps }), (0, jsx_runtime_1.jsx)(PageFrame_1.PageFrame, { locale: locale, localeChange: changeLocale, appType: web_consumer_nav_1.ConsumerApp.Unset, pageType: pageType, downloadUrl: (0, downloadUrlGenerator_1.generateAttributedDownloadUrl)(pageType), webPageViewTraceId: traceId, children: (0, jsx_runtime_1.jsx)(NoContentPage_1.NoContent, { pageType: pageType, locale: locale, changeLocale: changeLocale, reason: NoContentPage_1.Reason.ERROR_OCCURED, hideFooter: true }) })] }));
}
exports.ErrorPage = ErrorPage;
//# sourceMappingURL=index.js.map